var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./internal'),
    request = _require.request,
    requestConfig = _require.requestConfig,
    offlineSerialize = _require.offlineSerialize,
    util = _require.util,
    RPC = _require.RPC;

var defaultEnv = requestConfig.defaultEnv;

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    errorHandler = _require$TierError.errorHandler,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
var protocolMethods = {
  VoteProposal: "tx.VoteProposal"
};
/**
 * @description Offline rawTx generator of creating proposal
 * @param parameters {Object} object of parameters
 * @param parameters.proposalType {number} ProposalType. ConfigUpdate: 0x20, CodeChange: 0x21, General: 0x22
 * @param parameters.description {string} Description
 * @param parameters.proposer {string} Proposer
 * @param parameters.initialFunding {object} InitialFunding
 * @param parameters.initialFunding.currency {string} InitialFunding currency, must be OLT
 * @param parameters.initialFunding.value {string} InitialFunding value
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>} rawTx with fee estimation and proposalID
 */

function proposalCreateTxOffline(_x) {
  return _proposalCreateTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of canceling proposal
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} ProposalID
 * @param parameters.proposer {number} proposer
 * @param parameters.reason {string} cancel reason
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>} rawTx with fee estimation
 */


function _proposalCreateTxOffline() {
  _proposalCreateTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var proposalType,
        description,
        headline,
        proposer,
        initialFunding,
        _ref$gasAdjustment,
        gasAdjustment,
        env,
        initialFundingResult,
        gasPrice,
        _ref8,
        response,
        proposalOptions,
        _proposalOptions,
        fundingDeadline,
        votingDeadline,
        fundingGoal,
        passPercentage,
        txPayload,
        assembledTxForID,
        hashedProposalID,
        txPayloadFinal,
        assembledTx,
        gas,
        feeEstimationResult,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            proposalType = _ref.proposalType, description = _ref.description, headline = _ref.headline, proposer = _ref.proposer, initialFunding = _ref.initialFunding, _ref$gasAdjustment = _ref.gasAdjustment, gasAdjustment = _ref$gasAdjustment === void 0 ? 0 : _ref$gasAdjustment;
            env = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultEnv;

            if (!util.isEmpty(description)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalDescription)));

          case 4:
            if (!util.isEmpty(headline)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalHeadline)));

          case 6:
            if (util.isValidOLTAddress(proposer)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 8:
            if (util.getKeyByValue(requestConfig.ProposalTypes, proposalType)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalType)));

          case 10:
            if (!(initialFunding.currency !== requestConfig.OLT.currency)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.UnsupportedCurrency)));

          case 12:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 14:
            initialFundingResult = util.requestPriceConverter(initialFunding.value, requestConfig.OLT.decimal);

            if (initialFundingResult) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 17:
            initialFunding.value = initialFundingResult;
            _context.prev = 18;
            _context.next = 21;
            return request.queryGasPrice(env);

          case 21:
            _ref8 = _context.sent;
            response = _ref8.response;
            gasPrice = response;
            _context.next = 29;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](18);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 29:
            _context.prev = 29;
            _context.next = 32;
            return request.calculateProposalInfo(proposalType, env);

          case 32:
            proposalOptions = _context.sent;
            _context.next = 38;
            break;

          case 35:
            _context.prev = 35;
            _context.t1 = _context["catch"](29);
            return _context.abrupt("return", Promise.reject(_context.t1));

          case 38:
            _proposalOptions = proposalOptions, fundingDeadline = _proposalOptions.fundingDeadline, votingDeadline = _proposalOptions.votingDeadline, fundingGoal = _proposalOptions.fundingGoal, passPercentage = _proposalOptions.passPercentage;
            txPayload = {
              proposalType: proposalType,
              proposalDescription: description,
              proposalHeadline: headline,
              proposerAddress: proposer,
              initialFunding: initialFunding,
              fundingDeadline: fundingDeadline,
              votingDeadline: votingDeadline,
              fundingGoal: fundingGoal,
              passPercentage: passPercentage
            };
            assembledTxForID = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_CREATE, txPayload, gasPrice, gasAdjustment);
            _context.prev = 41;
            _context.next = 44;
            return util.hash(JSON.stringify(assembledTxForID));

          case 44:
            hashedProposalID = _context.sent;
            _context.next = 50;
            break;

          case 47:
            _context.prev = 47;
            _context.t2 = _context["catch"](41);
            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 50:
            if (!util.isEmpty(hashedProposalID)) {
              _context.next = 52;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 52:
            txPayloadFinal = _objectSpread({}, txPayload, {
              proposalId: hashedProposalID
            });
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_CREATE, txPayloadFinal, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context.next = 57;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 57:
            feeEstimationResult = _context.sent;
            return _context.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }, {
              proposalID: hashedProposalID
            }))));

          case 59:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[18, 26], [29, 35], [41, 47]]);
  }));
  return _proposalCreateTxOffline.apply(this, arguments);
}

function proposalCancelTxOffline(_x2) {
  return _proposalCancelTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of funding proposal
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} proposalID
 * @param parameters.funderAddress {string} funder Address
 * @param parameters.fundValue {object} fundValue
 * @param parameters.fundValue.currency {string} currency of fund, must be OLT
 * @param parameters.fundValue.value {string} value of fund
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>}  rawTx with fee estimation
 */


function _proposalCancelTxOffline() {
  _proposalCancelTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref2) {
    var proposalID,
        proposer,
        reason,
        _ref2$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        _ref9,
        response,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalID = _ref2.proposalID, proposer = _ref2.proposer, reason = _ref2.reason, _ref2$gasAdjustment = _ref2.gasAdjustment, gasAdjustment = _ref2$gasAdjustment === void 0 ? 0 : _ref2$gasAdjustment;
            env = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (!util.isEmpty(reason)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidCancelReason)));

          case 6:
            if (util.isValidOLTAddress(proposer)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 8:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 10:
            _context2.prev = 10;
            _context2.next = 13;
            return request.queryGasPrice(env);

          case 13:
            _ref9 = _context2.sent;
            response = _ref9.response;
            gasPrice = response;
            _context2.next = 21;
            break;

          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](10);
            return _context2.abrupt("return", Promise.reject(_context2.t0));

          case 21:
            tx_dataObj = {
              proposalId: proposalID,
              proposerAddress: proposer,
              cancelReason: reason
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_CANCEL, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context2.next = 26;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 26:
            feeEstimationResult = _context2.sent;
            return _context2.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[10, 18]]);
  }));
  return _proposalCancelTxOffline.apply(this, arguments);
}

function proposalFundTxOffline(_x3) {
  return _proposalFundTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of withdrawal proposal
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} proposalID
 * @param parameters.funder {string} funder
 * @param parameters.withdrawalValue {object} withdrawValue
 * @param parameters.withdrawalValue.currency {string} currency of withdrawal, must be OLT
 * @param parameters.withdrawalValue.value {string} value of withdrawal
 * @param parameters.beneficiary {string}
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>}  rawTx with fee estimation
 */


function _proposalFundTxOffline() {
  _proposalFundTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref3) {
    var proposalID,
        funderAddress,
        fundValue,
        _ref3$gasAdjustment,
        gasAdjustment,
        env,
        fundingResult,
        gasPrice,
        _ref10,
        response,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalID = _ref3.proposalID, funderAddress = _ref3.funderAddress, fundValue = _ref3.fundValue, _ref3$gasAdjustment = _ref3.gasAdjustment, gasAdjustment = _ref3$gasAdjustment === void 0 ? 0 : _ref3$gasAdjustment;
            env = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (util.isValidOLTAddress(funderAddress)) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 6:
            if (!(fundValue.currency !== requestConfig.OLT.currency)) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.UnsupportedCurrency)));

          case 8:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 10:
            fundingResult = util.requestPriceConverter(fundValue.value, requestConfig.OLT.decimal);

            if (fundingResult) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 13:
            fundValue.value = fundingResult;
            _context3.prev = 14;
            _context3.next = 17;
            return request.queryGasPrice(env);

          case 17:
            _ref10 = _context3.sent;
            response = _ref10.response;
            gasPrice = response;
            _context3.next = 25;
            break;

          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](14);
            return _context3.abrupt("return", Promise.reject(_context3.t0));

          case 25:
            tx_dataObj = {
              proposalId: proposalID,
              funderAddress: funderAddress,
              fundValue: fundValue
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_FUND, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context3.next = 30;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 30:
            feeEstimationResult = _context3.sent;
            return _context3.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 32:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[14, 22]]);
  }));
  return _proposalFundTxOffline.apply(this, arguments);
}

function withdrawalFundsTxOffline(_x4) {
  return _withdrawalFundsTxOffline.apply(this, arguments);
}
/**
 * @description Online rawTx generator of voting proposal
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} proposalID
 * @param parameters.address {string} voting address
 * @param parameters.opinion {number} opinion. YES: 0x1, NO: 0x2, GIVEUP: 0x3
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>}  rawTx with fee estimation and signature
 */


function _withdrawalFundsTxOffline() {
  _withdrawalFundsTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(_ref4) {
    var proposalID,
        funder,
        withdrawalValue,
        beneficiary,
        _ref4$gasAdjustment,
        gasAdjustment,
        env,
        withdrawalValueResult,
        gasPrice,
        _ref11,
        response,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            proposalID = _ref4.proposalID, funder = _ref4.funder, withdrawalValue = _ref4.withdrawalValue, beneficiary = _ref4.beneficiary, _ref4$gasAdjustment = _ref4.gasAdjustment, gasAdjustment = _ref4$gasAdjustment === void 0 ? 0 : _ref4$gasAdjustment;
            env = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (!(!util.isValidOLTAddress(funder) || !util.isValidOLTAddress(beneficiary))) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 6:
            if (!(withdrawalValue.currency !== requestConfig.OLT.currency)) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.UnsupportedCurrency)));

          case 8:
            withdrawalValueResult = util.requestPriceConverter(withdrawalValue.value, requestConfig.OLT.decimal);

            if (withdrawalValueResult) {
              _context4.next = 11;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 11:
            withdrawalValue.value = withdrawalValueResult; // check gasAdjustment if provided

            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context4.next = 14;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 14:
            _context4.prev = 14;
            _context4.next = 17;
            return request.queryGasPrice(env);

          case 17:
            _ref11 = _context4.sent;
            response = _ref11.response;
            gasPrice = response;
            _context4.next = 25;
            break;

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](14);
            return _context4.abrupt("return", Promise.reject(_context4.t0));

          case 25:
            tx_dataObj = {
              proposalId: proposalID,
              funderAddress: funder,
              withdrawValue: withdrawalValue,
              beneficiaryAddress: beneficiary
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_WITHDRAW_FUNDS, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context4.next = 30;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 30:
            feeEstimationResult = _context4.sent;
            return _context4.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 32:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[14, 22]]);
  }));
  return _withdrawalFundsTxOffline.apply(this, arguments);
}

function voteProposalTxOffline(_x5) {
  return _voteProposalTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of proposal expire vote
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} proposalID
 * @param parameters.validatorAddress {string} validator Address
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>}  rawTx with fee estimation
 */


function _voteProposalTxOffline() {
  _voteProposalTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(_ref5) {
    var proposalID,
        address,
        opinion,
        _ref5$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        _ref12,
        response,
        validEnvObj,
        headers,
        method,
        body,
        json,
        options,
        assembledTx,
        _assembledTx$fee,
        gas,
        price,
        feeEstimationResult,
        _args5 = arguments;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            proposalID = _ref5.proposalID, address = _ref5.address, opinion = _ref5.opinion, _ref5$gasAdjustment = _ref5.gasAdjustment, gasAdjustment = _ref5$gasAdjustment === void 0 ? 0 : _ref5$gasAdjustment;
            env = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (util.isValidOLTAddress(address)) {
              _context5.next = 6;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 6:
            if (util.getKeyByValue(requestConfig.VoteOpinions, opinion)) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidVoteOpinion)));

          case 8:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context5.next = 10;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 10:
            _context5.prev = 10;
            _context5.next = 13;
            return request.queryGasPrice(env);

          case 13:
            _ref12 = _context5.sent;
            response = _ref12.response;
            gasPrice = response;
            _context5.next = 21;
            break;

          case 18:
            _context5.prev = 18;
            _context5.t0 = _context5["catch"](10);
            return _context5.abrupt("return", Promise.reject(_context5.t0));

          case 21:
            _context5.next = 23;
            return util.verifyEnvParam(env).catch(function (error) {
              return Promise.reject(error);
            });

          case 23:
            validEnvObj = _context5.sent;
            headers = {
              "Content-Type": "application/json",
              Accept: "application/json"
            };
            method = "POST";
            body = {
              jsonrpc: "2.0",
              method: "",
              id: 1
            };
            json = true;
            options = {
              method: method,
              headers: headers,
              body: body,
              json: json,
              timeout: 3000
            };
            options["url"] = validEnvObj.url;
            body.method = protocolMethods.VoteProposal;
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_VOTE, "", gasPrice, gasAdjustment);
            _assembledTx$fee = assembledTx.fee, gas = _assembledTx$fee.gas, price = _assembledTx$fee.price;
            body["params"] = {
              proposalId: proposalID,
              address: address,
              opinion: opinion,
              gasPrice: price,
              gas: gas
            };
            _context5.next = 36;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 36:
            feeEstimationResult = _context5.sent;
            return _context5.abrupt("return", RPC.returnPromise(options).then(function (response) {
              var rawTx = response.rawTx,
                  signature = response.signature;

              var obj = _objectSpread({}, util.rawTxStructure(rawTx), {
                feeEstimation: feeEstimationResult.response
              });

              return Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, obj, {
                signature: signature
              })));
            }).catch(function (err) {
              return errorHandler(ErrorUtil.errorWrap(err));
            }));

          case 38:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[10, 18]]);
  }));
  return _voteProposalTxOffline.apply(this, arguments);
}

function expireVoteTxOffline(_x6) {
  return _expireVoteTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of proposal finalize
 * @param parameters {Object} object of parameters
 * @param parameters.proposalID {string} proposalID
 * @param parameters.validatorAddress {string} validator Address
 * @param [parameters.gasAdjustment] tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<{response: *}|{error: *}>}  rawTx with fee estimation
 */


function _expireVoteTxOffline() {
  _expireVoteTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(_ref6) {
    var proposalID,
        validatorAddress,
        _ref6$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        _ref13,
        response,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            proposalID = _ref6.proposalID, validatorAddress = _ref6.validatorAddress, _ref6$gasAdjustment = _ref6.gasAdjustment, gasAdjustment = _ref6$gasAdjustment === void 0 ? 0 : _ref6$gasAdjustment;
            env = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context6.next = 4;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (util.isValidOLTAddress(validatorAddress)) {
              _context6.next = 6;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 6:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context6.next = 8;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 8:
            _context6.prev = 8;
            _context6.next = 11;
            return request.queryGasPrice(env);

          case 11:
            _ref13 = _context6.sent;
            response = _ref13.response;
            gasPrice = response;
            _context6.next = 19;
            break;

          case 16:
            _context6.prev = 16;
            _context6.t0 = _context6["catch"](8);
            return _context6.abrupt("return", Promise.reject(_context6.t0));

          case 19:
            tx_dataObj = {
              proposalId: proposalID,
              validatorAddress: validatorAddress
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.EXPIRE_VOTES, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context6.next = 24;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 24:
            feeEstimationResult = _context6.sent;
            return _context6.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 26:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[8, 16]]);
  }));
  return _expireVoteTxOffline.apply(this, arguments);
}

function finalizeProposalTxOffline(_x7) {
  return _finalizeProposalTxOffline.apply(this, arguments);
}

function _finalizeProposalTxOffline() {
  _finalizeProposalTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(_ref7) {
    var proposalID,
        validatorAddress,
        _ref7$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        _ref14,
        response,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            proposalID = _ref7.proposalID, validatorAddress = _ref7.validatorAddress, _ref7$gasAdjustment = _ref7.gasAdjustment, gasAdjustment = _ref7$gasAdjustment === void 0 ? 0 : _ref7$gasAdjustment;
            env = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : defaultEnv;

            if (!util.isEmpty(proposalID)) {
              _context7.next = 4;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidProposalID)));

          case 4:
            if (util.isValidOLTAddress(validatorAddress)) {
              _context7.next = 6;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 6:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context7.next = 8;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 8:
            _context7.prev = 8;
            _context7.next = 11;
            return request.queryGasPrice(env);

          case 11:
            _ref14 = _context7.sent;
            response = _ref14.response;
            gasPrice = response;
            _context7.next = 19;
            break;

          case 16:
            _context7.prev = 16;
            _context7.t0 = _context7["catch"](8);
            return _context7.abrupt("return", Promise.reject(_context7.t0));

          case 19:
            tx_dataObj = {
              proposalId: proposalID,
              validatorAddress: validatorAddress
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.PROPOSAL_FINALIZE, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context7.next = 24;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 24:
            feeEstimationResult = _context7.sent;
            return _context7.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 26:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[8, 16]]);
  }));
  return _finalizeProposalTxOffline.apply(this, arguments);
}

module.exports = {
  proposalCreateTxOffline: proposalCreateTxOffline,
  proposalCancelTxOffline: proposalCancelTxOffline,
  proposalFundTxOffline: proposalFundTxOffline,
  withdrawalFundsTxOffline: withdrawalFundsTxOffline,
  voteProposalTxOffline: voteProposalTxOffline,
  expireVoteTxOffline: expireVoteTxOffline,
  finalizeProposalTxOffline: finalizeProposalTxOffline
};